<template>

    <div class="page-content">
        <div class="container-fluid">

            <Breadcrumb
                :pgTitle="$t('nav.employees')"
                :pgIcon="'bx bx-user-pin'"
                :refs="refs"
                :pgCurrent="pgCurrent"
                :addNew="false">
            </Breadcrumb>

            <div class="row">

                <Loading
                    v-if="pgLoading">
                </Loading>

                <div v-if="!pgLoading" class="col-8">

                    <FormEmployee
                        :label="$t('view.employee_info')"
                        
                        :full_name="row.full_name"
                        :employee_category_id="row.employee_category_id"
                        :job_title_id="row.job_title_id"
                        :phone="row.phone"
                        :nationality_id="row.nationality_id"
                        :civil_no="row.civil_no"
                        :passport_no="row.passport_no"
                        :passport_expire_date="row.passport_expire_date"
                        :hiring_date="row.hiring_date"
                        :residence_expire_date="row.residence_expire_date"
                        :start_working_date="row.start_working_date"
                        :end_working_date="row.end_working_date"
                        :salary="row.salary"
                        :salary_per_day="row.salary_per_day"
                        :bank_iban_no="row.bank_iban_no"
                        :bank_name="row.bank_name"
                        :bank_branch_name="row.bank_branch_name"
                        :bank_credit_no="row.bank_credit_no"
                        :bank_password="row.bank_password"
                        :license_no="row.license_no"
                        :license_expire_date="row.license_expire_date"
                        
                        v-on:formChange="handleFormChange">
                    </FormEmployee>

                </div>

                <div v-if="!pgLoading" class="col-4">

                    <CardImage
                        :labelImage="$t('view.employee_image')"
                        :image_base64="row.image_baes64"
                        :image_preview="row.image_preview"
                        v-on:imageChange="handleImageChange">
                    </CardImage>

                    <CardAttachments
                        :labelAttachment="$t('view.attachemnts')"
                        :attachments="row.attachments"
                        :attachment_key="row.attachment_key"
                        v-on:attachmentChange="handleAttachmentChange">
                    </CardAttachments>

                    <CardStatus
                        :status="row.status"
                        v-on:statusChange="handleStatusChange">
                    </CardStatus>
                
                </div>
            </div>


            <Buttons
                v-if="!pgLoading"
                :btnLoading="btnLoading"
                :btnCurrent="btnCurrent"
                        
                v-on:submitClicked="handelSubmit"
                v-on:cancelClicked="handleCancel">
            </Buttons>

        </div>
    </div>

</template>

<script>
import iziToast from 'izitoast';

export default {
    name: 'EditOrNew',
    components: {
        Breadcrumb: () => import('@/components/Breadcrumb.vue'),
        Loading: () => import('@/components/Loading.vue'),
        FormEmployee: () => import('@/components/FormEmployee.vue'),
        CardImage: () => import('@/components/CardImage.vue'),
        CardAttachments: () => import('@/components/CardAttachments.vue'),
        CardStatus: () => import('@/components/CardStatus.vue'),
        Buttons: () => import('@/components/Buttons.vue')
    },
    data(){
        return {    
            // auth
            auth: {
                role: '',
                access_token: '',
            },

            // row
            row: {
                full_name: '',
                employee_category_id: '',
                job_title_id: '',
                phone: '',
                nationality_id: '',
                civil_no: '',
                passport_no: '',
                passport_expire_date: '',
                hiring_date: '',
                residence_expire_date: '',
                start_working_date: '',
                end_working_date: '',
                salary: '',
                salary_per_day: '',
                bank_iban_no: '',
                bank_name: '',
                bank_branch_name: '',
                bank_credit_no: '',
                bank_password: '',
                license_no: '',
                license_expire_date: '',

                image_base64: '',
                image_preview: '',
                
                attachment_key: 0,
                attachments: [],
                attachment_base64: [],

                status: 1,
            },
                
            msgCurrent: (this.$route.params.id) ? 'Updated' : 'Created',
            btnCurrent: (this.$route.params.id) ? 'Update' : 'Create',
            methodType: (this.$route.params.id) ? 'PUT' : 'POST',
            pgLoading: (this.$route.params.id) ? true : false,
            pgCurrent: (this.$route.params.id) ? 'Edit' : 'Add New',
            btnLoading: false,
            
            refs: 'employees',
        }
    },
    mounted() {},
    created() {
        // AccessToken & Role
        if(localStorage.getItem('access_token')) {
            this.auth.access_token = localStorage.getItem('access_token');
        }
        if(localStorage.getItem('role')) {
            this.auth.role = localStorage.getItem('role');
        }

        if(this.$route.params.id) {
            this.fetchRow();
        }
    },
    methods: {
        
        // fetch Row
        fetchRow() {
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/'+this.refs+'/'+this.$route.params.id,
                method: 'GET',
                data: {}
            }
            this.axios(options)
            .then(res => {
                this.pgLoading = false;

                this.row.full_name = res.data.row.full_name;
                this.row.employee_category_id = res.data.row.employee_category_id;
                this.row.job_title_id = res.data.row.job_title_id;
                this.row.phone = res.data.row.phone;
                this.row.nationality_id = res.data.row.nationality_id;
                this.row.civil_no = res.data.row.civil_no;
                this.row.passport_no = res.data.row.passport_no;
                this.row.passport_expire_date = res.data.row.passport_expire_date;
                this.row.hiring_date = res.data.row.hiring_date;
                this.row.residence_expire_date = res.data.row.residence_expire_date;
                this.row.start_working_date = res.data.row.start_working_date;
                this.row.end_working_date = res.data.row.end_working_date;
                this.row.salary = res.data.row.salary;
                this.row.salary_per_day = res.data.row.salary_per_day;
                this.row.bank_iban_no = res.data.row.bank_iban_no;
                this.row.bank_name = res.data.row.bank_name;
                this.row.bank_branch_name = res.data.row.bank_branch_name;
                this.row.bank_credit_no = res.data.row.bank_credit_no;
                this.row.bank_password = res.data.row.bank_password;
                this.row.license_no = res.data.row.license_no;
                this.row.license_expire_date = res.data.row.license_expire_date;

                this.row.image_preview = (res.data.row.image) ? res.data.row.image.url : '';
                this.row.image_base64 = (res.data.row.image) ? res.data.row.image.url : '';
                
                // attacments
                this.row.attachment_key = res.data.row.attachment_key;
                if(res.data.row.attachments) {
                    for(let i = 1; i <= this.row.attachment_key; i++) {
                        let x = i-1;
                        this.row.attachments[i] = (res.data.row.attachments[x]) 
                                                        ? res.data.row.attachments[x].url 
                                                        : '';
                    }
                }

                this.row.status = res.data.row.status;
            })
            .catch(err => {

                // 403 Forbidden
                if(err.response && err.response.status == 401) {
                    this.clearLocalStorage();
                    this.$router.push({ name: 'login' });
                } else if(err.response && err.response.status == 403) {
                    this.$router.push({ name: 'forbidden' });
                } else {
                    this.btnLoading = false;
                    iziToast.warning({
                        icon: 'bx bx-angry',
                        title: '',
                        message: (err.response) ? err.response.data.message : ''+err
                    });
                }

            })
            .finally(() => {});
        },
            

        // handle edit Or New submit
        handelSubmit(){
            this.btnLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };

            const config = { headers: { 'Content-Type': 'multipart/form-data' }};  
            const options = {
                url: (this.$route.params.id) ? window.baseURL+'/'+this.refs+'/'+this.$route.params.id : window.baseURL+'/'+this.refs,
                method: this.methodType,
                data: {

                    full_name: this.row.full_name,
                    employee_category_id: this.row.employee_category_id,
                    job_title_id: this.row.job_title_id,
                    nationality_id: this.row.nationality_id,
                    civil_no: this.row.civil_no,
                    passport_no: this.row.passport_no,
                    passport_expire_date: this.row.passport_expire_date,
                    hiring_date: this.row.hiring_date,
                    residence_expire_date: this.row.residence_expire_date,
                    start_working_date: this.row.start_working_date,
                    end_working_date: this.row.end_working_date,
                    salary: this.row.salary,
                    salary_per_day: this.row.salary_per_day,
                    bank_iban_no: this.row.bank_iban_no,
                    bank_name: this.row.bank_name,
                    bank_branch_name: this.row.bank_branch_name,
                    bank_credit_no: this.row.bank_credit_no,
                    bank_password: this.row.bank_password,
                    license_no: this.row.license_no,
                    license_expire_date: this.row.license_expire_date,

                    image_base64: this.row.image_base64,
                    attachments: this.row.attachments,
                    status: this.row.status
                }
            }
            this.axios(options, config)
            .then(() => {
                this.btnLoading = false;
                iziToast.success({
                    icon: 'bx bx-wink-smile',
                    title: '',
                    message: (this.btnCurrent == 'Update') ? 'تم التعديل بنجاح' : 'تم الإضافة بنجاح'
                });
                    
                this.$router.push({ name: this.refs });
            })
            .catch(err => {
                        
                // 403 Forbidden
                if(err.response && err.response.status == 401) {
                    this.clearLocalStorage();
                    this.$router.push({ name: 'login' });
                } else if(err.response && err.response.status == 403) {
                    this.$router.push({ name: 'forbidden' });
                } else {
                    this.btnLoading = false;
                    iziToast.warning({
                        icon: 'bx bx-angry',
                        title: '',
                        message: (err.response) ? err.response.data.message : ''+err
                    });
                }
            })
            .finally(() => {})

        },

          
        // clear Local Storage
        clearLocalStorage() {
            localStorage.removeItem('access_token');
            localStorage.removeItem('avatar');
            localStorage.removeItem('username');
            localStorage.removeItem('encrypt_id');
            localStorage.removeItem('role');
        },


        // Cancel
        handleCancel(){
            if(confirm('هل انت متأكد؟')) {
                this.$router.push({ name: this.refs });
            }
        },


        // handel Changes from child components
        handleFormChange(event) {
            this.row.full_name = event.full_name;
            this.row.employee_category_id = event.employee_category_id;
            this.row.job_title_id = event.job_title_id;
            this.row.phone = event.phone;
            this.row.nationality_id = event.nationality_id;
            this.row.civil_no = event.civil_no;
            this.row.passport_no = event.passport_no;
            this.row.passport_expire_date = event.passport_expire_date;
            this.row.hiring_date = event.hiring_date;
            this.row.residence_expire_date = event.residence_expire_date;
            this.row.start_working_date = event.start_working_date;
            this.row.end_working_date = event.end_working_date;
            this.row.salary = event.salary;
            this.row.salary_per_day = event.salary_per_day;
            this.row.bank_iban_no = event.bank_iban_no;
            this.row.bank_name = event.bank_name;
            this.row.bank_branch_name = event.bank_branch_name;
            this.row.bank_credit_no = event.bank_credit_no;
            this.row.bank_password = event.bank_password;
            this.row.license_no = event.license_no;
            this.row.license_expire_date = event.license_expire_date;
        },

        handleImageChange(event) {
            this.row.image_base64 = event.image_base64;
        },

        handleAttachmentChange(event) {
            this.row.attachments = event.attachments;
            this.row.attachment_key = event.attachment_key;
        },

        handleStatusChange(event) {
            this.row.status = event.status;
        },

    },
}
</script>
